export const translations = {
  // Map bot-verification gate
  mapGate: {
    blocked: 'We konden je browser niet verifiëren, dus de kaart is niet geladen.',
    slow: 'We controleren je browser nog. Rond de controle hierboven af om de kaart te laden.',
    retry: 'Opnieuw proberen',
  },
  // Rating labels
  ratings: {
    terrible: 'Verschrikkelijk',
    poor: 'Slecht',
    okay: 'Oké',
    good: 'Goed',
    excellent: 'Uitstekend',
  },
  // Navigation and UI
  navigation: {
    home: 'Home',
    about: 'Over Ons',
    faq: 'Veelgestelde Vragen',
    howTo: 'Hoe Controleren',
    privacy: 'Privacybeleid',
    search: 'Zoek restaurants...',
    languageSwitch: 'Schakel naar Engels',
    reportPoisoning: 'Meld Voedselvergiftiging',
    guide: 'Voedselveiligheidsgids',
    rights: 'Consumentenrechten',
    symptoms: 'Symptomengids',
    navigation: 'Navigatie',
    features: 'Functies',
    chains: 'Ketens',
    chainsCompared: 'Ketens vergeleken',
    explore: 'Ontdek',
    inspectionBacklog: 'Inspectie-achterstand',
    clickToCollapse: 'Klik om in te klappen',
    clickToExpand: 'Klik om uit te klappen',
    copyright: '© 2026 Kauwen of Spauwen. Alle rechten voorbehouden.'
  },

  // Homepage content
  homepage: {
    title: 'Controleer Restaurant Hygiëne Voor Je Eet',
    subtitle: 'Voedselveiligheid Beoordelingen & Hygiëne Inspectie Resultaten',
    description: 'Controleer restaurant hygiëne scores voor je gaat eten. Bekijk voedselveiligheid inspecties, lees meldingen van andere gasten, en maak geïnformeerde keuzes. Meld voedselvergiftiging anoniem.',
    searchPlaceholder: 'Zoek een restaurant om hygiëne te controleren...',
    welcomeMessage: 'Controleer je restaurant voor je eet',
    featuresTitle: 'Maak Veiligere Keuzes',
    anonymousReporting: 'Meld voedselvergiftiging anoniem - geen registratie nodig',
    officialData: 'Bekijk officiële hygiëne inspectie resultaten',
    realTimeUpdates: 'Real-time voedselveiligheid meldingen van andere gasten',
    ctaReport: 'Meld Voedselvergiftiging',
    ctaCheck: 'Controleer Restaurant Hygiëne',
    recentReports: 'Recente Voedselveiligheid Meldingen',
    worstRated: 'Te Vermijden Restaurants - Slechte Hygiëne Scores'
  },

  // Restaurant details
  restaurant: {
    details: 'Restaurant Details',
    address: 'Adres',
    inspectionRating: 'Inspectiebeoordeling',
    lastInspection: 'Laatste Inspectie',
    operatorInfo: 'Exploitant Informatie',
    reportIssue: 'Meld Voedselveiligheidsprobleem',
    viewOnMap: 'Bekijk op Kaart',
    safetyScore: 'Voedselveiligheidsscore',
    hygieneRating: 'Hygiënebeoordeling',
    inspectionHistory: 'Inspectiegeschiedenis',
    noInspectionData: 'Geen inspectiegegevens beschikbaar',
    ratingExcellent: 'Uitstekend',
    ratingGood: 'Goed',
    ratingFair: 'Redelijk',
    ratingPoor: 'Slecht',
    ratingUnknown: 'Onbekend',
    share: 'Delen',
    close: 'Sluiten',
    copied: 'Gekopieerd!',
    shareTitle: '{{name}} - Kauwen of Spauwen',
    shareText: 'Bekijk {{name}} op Kauwen of Spauwen!',
    detailsAndHistory: 'Details & Geschiedenis',
    expandDetails: 'Toon details',
    collapseDetails: 'Verberg details',
    loadingDetails: 'Restaurant details laden...',
    userReports: 'Gebruikersrapporten',
    noReportsYet: 'Nog geen meldingen voor dit restaurant',
    beFirstToReport: 'Wees de eerste om een melding toe te voegen!',
    addReport: 'Voeg een melding toe',
    tryAgain: 'Probeer Opnieuw',
    noScoreChange: 'Geen verandering in score',
    inspectionSource: {
      title: 'Bron van Inspectiegegevens',
      description: 'De hier weergegeven inspectieresultaten komen uit de officiële Belgische voedselveiligheidsdatabase die wordt beheerd door het Federaal Agentschap voor de Veiligheid van de Voedselketen (FAVV).',
      moreInfo: 'Voor meer gedetailleerde informatie over de inspectiegeschiedenis van dit restaurant, kunt u',
      viewOnFoodweb: 'bekijken op Foodweb',
      info: 'Informatie over bron van inspectiegegevens'
    }
  },

  // Search and filters
  search: {
    placeholder: 'Zoek restaurants, steden of adressen...',
    noResults: 'Geen restaurants gevonden',
    searching: 'Zoeken...',
    filterByRating: 'Filter op Veiligheidsbeoordeling',
    showAll: 'Toon Alles',
    nearMe: 'Bij Mij in de Buurt',
    recentReports: 'Recente Meldingen',
    clearFilters: 'Filters Wissen',
    enterRestaurantName: 'Voer restaurant naam in...',
    loading: 'Laden...',
    noResultsFound: 'Geen resultaten gevonden.',
    recentlyViewed: 'Recent bekeken',
    clearRecent: 'Wissen',
    emojiMeaningsQuestion: 'Wat betekenen deze emoji\'s?'
  },

  // Forms and reporting
  forms: {
    reportTitle: 'Meld Voedselvergiftiging',
    restaurantName: 'Restaurant Naam',
    issueDescription: 'Beschrijf je voedselvergiftiging ervaring',
    dateOfVisit: 'Wanneer heb je daar gegeten?',
    symptoms: 'Voedselvergiftiging Symptomen',
    submit: 'Verstuur Voedselvergiftiging Melding',
    submitting: 'Melding versturen...',
    thankYou: 'Bedankt voor het melden van voedselvergiftiging',
    required: 'Verplicht veld',
    optional: 'Optioneel',
    anonymous: 'Je voedselvergiftiging melding is 100% anoniem',
    symptomsList: {
      nausea: 'Misselijkheid',
      vomiting: 'Braken',
      diarrhea: 'Diarree',
      fever: 'Koorts',
      cramps: 'Buikkrampen',
      headache: 'Hoofdpijn'
    },
    whenSick: 'Wanneer werd je ziek?',
    whatAte: 'Wat heb je gegeten?',
    howMany: 'Hoeveel mensen werden ziek?'
  },

  // About page content
  about: {
    title: 'Over Ons Gemeenschapsplatform voor Voedselveiligheid',
    subtitle: 'Anonieme melding van voedselvergiftiging om de volksgezondheid te beschermen',
    missionTitle: 'Onze Missie',
    missionText: 'Wij zijn een gemeenschapsgedreven platform gewijd aan het voorkomen van voedselvergiftiging. Door consumenten in staat te stellen anoniem hun negatieve ervaringen in restaurants te melden, creëren we een gezamenlijke database die iedereen helpt veiligere eetkeuzes te maken. Ons systeem biedt real-time inzichten op basis van werkelijke klantervaringen.',
    howItWorksTitle: 'Hoe Het Werkt',
    step1Title: 'Anoniem Melden',
    step1Text: 'Meld voedselvergiftiging zonder een account aan te maken. Je identiteit blijft volledig vertrouwelijk.',
    step2Title: 'Gemeenschapsvalidatie',
    step2Text: 'Meerdere meldingen van hetzelfde etablissement creëren een waarschuwingspatroon voor andere gasten.',
    step3Title: 'Actieve Preventie',
    step3Text: 'Controleer recente meldingen en hygiënescores voordat je kiest waar je gaat eten.',
    dataSourcesTitle: 'Onze Gegevensbronnen',
    dataSourcesText: 'We combineren twee soorten informatie om je een volledig beeld van voedselveiligheid te geven:',
    privacyTitle: 'Jouw Privacy Is Onze Prioriteit',
    privacyText: 'Alle meldingen zijn 100% anoniem. We verzamelen geen persoonlijk identificeerbare informatie. Je melding helpt de gemeenschap terwijl je identiteit wordt beschermd.',
    whyImportantTitle: 'Waarom Dit Belangrijk Is',
    whyImportantText: 'Voedselvergiftiging treft jaarlijks duizenden mensen. Veel gevallen worden nooit gemeld aan officiële instanties. Ons platform maakt snelle en eenvoudige melding mogelijk die verdere gevallen kan voorkomen en restaurants kan aanmoedigen hoge hygiënenormen te handhaven.',
    communityImpactTitle: 'Gemeenschapsimpact',
    stat1: 'Anonieme meldingen verwerkt',
    stat2: 'Restaurants gemonitord',
    stat3: 'Maandelijks actieve gebruikers',
    joinUsTitle: 'Sluit Je Aan Bij Onze Gemeenschap',
    joinUsText: 'Samen kunnen we een veiliger eetomgeving creëren voor iedereen.'
  },

  // FAQ content
  faq: {
    title: 'Voedselvergiftiging & Restaurant Hygiëne FAQs',
    subtitle: 'Veelgestelde vragen over voedselvergiftiging melden',
    q1: 'Hoe meld ik voedselvergiftiging?',
    a1: 'Je kunt voedselvergiftiging anoniem melden op ons platform door het restaurant te zoeken en een melding in te dienen. Dit helpt andere gasten direct te waarschuwen.',
    q2: 'Wat zijn symptomen van voedselvergiftiging?',
    a2: 'Veelvoorkomende voedselvergiftiging symptomen zijn misselijkheid, braken, diarree, buikkrampen, koorts en hoofdpijn. Symptomen beginnen meestal 2-6 uur na het eten van besmet voedsel.',
    q3: 'Hoe werkt dit platform?',
    a3: 'Ons platform biedt snelle, anonieme voedselvergiftiging meldingen. Meldingen zijn direct zichtbaar om anderen te helpen ziek worden te voorkomen.',
    q4: 'Hoe lang duurt voedselvergiftiging?',
    a4: 'De meeste voedselvergiftiging gevallen duren 1-3 dagen. Zoek medische hulp als symptomen langer aanhouden, je hoge koorts hebt, bloed in ontlasting of tekenen van uitdroging.',
    q5: 'Kan ik zien welke restaurants slechte hygiëne hebben?',
    a5: 'Ja, we tonen officiële hygiëne inspectie scores en voedselvergiftiging meldingen. Zoek naar restaurants met slechte beoordelingen of recente voedselvergiftiging meldingen.',
    q6: 'Kunnen restaurants reageren op meldingen?',
    a6: 'Restaurants kunnen contact met ons opnemen voor aanvullende context, maar alle meldingen blijven anoniem en zichtbaar.',
    q7: 'Wat betekenen de veiligheidsbeoordelingen?',
    a7: 'Veiligheidsbeoordelingen zijn gebaseerd op officiële inspectieresultaten, met aanvullende context van gemeenschapsmeldingen wanneer beschikbaar.'
  },

  // How-to guide content
  howTo: {
    title: 'Hoe Restaurant Voedselveiligheid Controleren',
    subtitle: 'Een uitgebreide gids voor het evalueren van restaurant hygiëne en veiligheid',
    introText: 'Geïnformeerde beslissingen nemen over waar je gaat eten is cruciaal voor je gezondheid en veiligheid. Hier is hoe je ons platform gebruikt en waar je op moet letten.',
    step1Title: 'Controleer Officiële Beoordelingen',
    step1Text: 'Begin met het bekijken van de inspectiebeoordeling. Deze weerspiegelt de naleving van hygiënenormen door het restaurant.',
    step2Title: 'Bekijk Inspectiegeschiedenis',
    step2Text: 'Kijk naar de inspectiegeschiedenis om trends over tijd te zien. Recente verbeteringen of terugkerende problemen kunnen waardevolle inzichten bieden.',
    step3Title: 'Lees Gemeenschapsmeldingen',
    step3Text: 'Anonieme gemeenschapsmeldingen kunnen real-world ervaringen en recente zorgen bieden die mogelijk nog niet zijn weerspiegeld in officiële inspecties.',
    step4Title: 'Overweeg Locatie en Type',
    step4Text: 'Verschillende soorten etablissementen kunnen verschillende risicoprofielen hebben. Overweeg het type keuken en bereidingsmethoden.',
    warningSignsTitle: 'Waarschuwingssignalen om Op Te Letten',
    warningSign1: 'Meerdere recente negatieve meldingen',
    warningSign2: 'Dalende inspectiescores over tijd',
    warningSign3: 'Slechte hygiënebeoordelingen in recente inspecties',
    warningSign4: 'Meldingen van voedselgerelateerde ziektes',
    tipsTitle: 'Aanvullende Veiligheidstips',
    tip1: 'Vertrouw op je intuïtie - als iets niet klopt, overweeg dan ergens anders te eten',
    tip2: 'Controleer of het restaurant hun hygiënebeoordeling prominent toont',
    tip3: 'Let op tekenen van netheid in zichtbare gebieden',
    tip4: 'Overweeg de versheid en temperatuur van voedsel wanneer het wordt geserveerd'
  },

  // Privacy policy content
  privacy: {
    title: 'Privacybeleid',
    subtitle: 'Hoe we je privacy beschermen en gegevens behandelen',
    lastUpdated: 'Laatst bijgewerkt: {{date}}',
    introTitle: 'Onze Toewijding aan Privacy',
    introText: 'We zijn toegewijd aan het beschermen van je privacy en ervoor zorgen dat alle meldingen volledig anoniem blijven.',
    dataCollectionTitle: 'Gegevensverzameling',
    dataCollectionText: 'We verzamelen alleen de minimale informatie die nodig is om ons platform te laten functioneren. Voor anonieme meldingen verzamelen we geen persoonlijk identificeerbare informatie.',
    anonymityTitle: 'Anonimiteitsgarantie',
    anonymityText: 'Alle voedselveiligheidsmeldingen zijn volledig anoniem. We volgen geen IP-adressen, vereisen geen accounts en verzamelen geen informatie die je zou kunnen identificeren.',
    dataUseTitle: 'Hoe We Gegevens Gebruiken',
    dataUseText: 'Gegevens worden uitsluitend gebruikt om voedselveiligheidsinformatie aan het publiek te verstrekken. We verkopen, delen of monetariseren gebruikersgegevens niet.',
    cookiesTitle: 'Cookies en Tracking',
    cookiesText: 'We gebruiken minimale cookies alleen voor essentiële functionaliteit. We gebruiken geen tracking cookies of analytics die anonimiteit zouden kunnen compromitteren.',
    contactTitle: 'Contact Opnemen',
    contactText: 'Als je vragen hebt over dit privacybeleid, neem dan contact met ons op via ons platform.'
  },

  // Common UI elements
  common: {
    loading: 'Laden...',
    error: 'Er is een fout opgetreden',
    retry: 'Opnieuw Proberen',
    search: 'Zoeken...',
    close: 'Sluiten',
    back: 'Terug',
    next: 'Volgende',
    previous: 'Vorige',
    save: 'Opslaan',
    cancel: 'Annuleren',
    confirm: 'Bevestigen',
    delete: 'Verwijderen',
    edit: 'Bewerken',
    view: 'Bekijken',
    share: 'Delen',
    copy: 'Kopiëren',
    copied: 'Gekopieerd!',
    showMore: 'Meer Tonen',
    showLess: 'Minder Tonen',
    readMore: 'Meer Lezen',
    readLess: 'Minder Lezen',
    tryAgain: 'Opnieuw Proberen',
    page: 'Pagina',
    of: 'van',
    perPage: 'per pagina',
    all: 'Alle',
    noResults: 'Geen resultaten gevonden',
    locateMe: 'Lokaliseer mij',
    toggleMenu: 'Menu schakelen',
    loadingRestaurant: 'Restaurant laden...',
    loadingDetails: 'Laden...',
    addYourReport: 'Voeg je melding toe',
    words: 'woorden',
    star: 'ster',
    stars: 'sterren'
  },

  // Reports section
  reports: {
    loading: 'Recente meldingen laden...',
    error: 'Kan meldingen niet laden',
    noReports: 'Geen recente meldingen beschikbaar',
    noReportsSubtext: 'Meldingen verschijnen hier zodra ze worden ingediend',
    latestReports: 'Laatste Voedselveiligheidsmeldingen',
    reports: 'Meldingen',
    summary: 'Recente Activiteit Samenvatting',
    totalReports: 'Totaal Meldingen',
    avgRating: 'Gem. Beoordeling',
    activeRestaurants: 'Recente Restaurants',
    activeCities: 'Actieve Steden',
    cta: 'Heeft u voedselveiligheidsproblemen ervaren? Deel uw ervaring om anderen te helpen geïnformeerde eetbeslissingen te nemen.'
  },

  // Navigation keys
  nav: {
    home: 'Home',
    about: 'Over Ons',
    faq: 'Veelgestelde Vragen',
    howToCheck: 'Hoe Te Controleren',
    privacy: 'Privacybeleid'
  },

  // SEO and meta content
  seo: {
    keywords: {
      foodSafety: 'voedselveiligheid',
      restaurantHygiene: 'restaurant hygiëne',
      foodPoisoning: 'voedselvergiftiging',
      restaurantRatings: 'restaurant beoordelingen',
      foodInspection: 'voedselinspectie',
      restaurants: 'restaurants',
      foodQuality: 'voedselkwaliteit',
      restaurantReviews: 'restaurant reviews',
      anonymousReporting: 'anonieme melding',
      hygieneRating: 'hygiëne beoordeling'
    }
  },

  // Emoji betekenissen
  emoji: {
    meanings: {
      title: 'Emoji Betekenissen',
      skull: 'Twee keer slechte inspectie met politierapport',
      sick: 'Mislukte inspectie met waarschuwing, wacht op herinspectie',
      slight_smile: 'Slechte inspectie maar problemen opgelost na herinspectie',
      smile: 'Geslaagd voor laatste inspectie',
      heart_eyes: 'Gevalideerd door extern bedrijf',
      question: 'Onbekende status of geen gegevens'
    },
    selectEmoji: 'Selecteer emoji: {{emoji}}'
  },

  // Wall of Shame
  wallOfShame: {
    title: 'Muur van Schande',
    subtitle: 'Toont etablissementen met de slechtste voedselveiligheid inspectieresultaten.',
    foundCount: '{{count}} etablissementen gevonden met "Te verbeteren" beoordeling',
    showingPage: 'Toont pagina',
    noEstablishments: 'Geen etablissementen met slechte beoordelingen gevonden.',
    columns: {
      id: 'ID',
      name: 'Naam',
      address: 'Adres',
      inspectionDate: 'Inspectiedatum',
      details: 'Details'
    }
  },

  // Data Table
  dataTable: {
    title: 'Gegevenstabel',
    filterByStatus: 'Filter op Status:',
    columns: {
      id: 'ID',
      name: 'Naam',
      address: 'Adres',
      status: 'Status',
      tooltip: 'Tooltip',
      inspectionResult: 'Inspectie resultaat'
    },
    statuses: {
      toImprove: 'Te verbeteren',
      good: 'Goed',
      veryGood: 'Zeer goed'
    }
  },

  // Report Form
  reportForm: {
    title: 'Nieuwe Melding Maken',
    createNewReport: 'Nieuwe Melding Maken',
    successMessage: 'Melding succesvol ingediend!',
    shareYourReport: 'Deel je melding',
    done: 'Klaar',
    anonymousUsername: 'Je Anonieme Gebruikersnaam',
    privacyNote: 'Voor privacy genereren we een willekeurige gebruikersnaam voor elke melding',
    yourUsername: 'Je Anonieme Gebruikersnaam',
    usernameInfo: 'Voor privacy genereren we een willekeurige gebruikersnaam voor elke melding',
    yourReport: 'Je Melding',
    placeholder: 'Deel je ervaring met dit restaurant...',
    reportPlaceholder: 'Deel je ervaring met dit restaurant...',
    wordCount: '{{count}} / {{max}} woorden',
    wordLimit: 'Houd je melding onder de {{limit}} woorden',
    wordLimitExceeded: 'Houd je melding onder de {{limit}} woorden',
    rateExperience: 'Beoordeel Je Ervaring',
    selectRating: 'Selecteer een beoordeling',
    selectedRating: 'Je beoordeelde dit restaurant {{rating}} van de 5 sterren',
    youRated: 'Je beoordeelde dit restaurant',
    submitting: 'Indienen...',
    addReport: 'Melding Toevoegen',
    cancel: 'Annuleren',
    addImage: 'Afbeelding Toevoegen (Optioneel)',
    clickToUpload: 'Klik om te uploaden',
    imageRequirements: 'PNG, JPG tot 15MB',
    imageTooLarge: 'Afbeelding moet kleiner zijn dan {{size}}',
    invalidImageType: 'Upload een geldige afbeelding',
    imageLoadError: 'Afbeelding laden mislukt',
    loadingImage: 'Afbeelding laden...',
    detailsOptional: 'Details (Optioneel)',
    symptomsLabel: 'Symptomen',
    visitDateLabel: 'Datum van bezoek',
    dishOrderedLabel: 'Besteld gerecht',
    dishOrderedPlaceholder: 'bijv. pasta, sushi...'
  },

  // Time formatting
  time: {
    justNow: 'zojuist',
    minuteAgo: '1 minuut geleden',
    minutesAgo: '{{count}} minuten geleden',
    hourAgo: '1 uur geleden',
    hoursAgo: '{{count}} uur geleden',
    dayAgo: '1 dag geleden',
    daysAgo: '{{count}} dagen geleden',
    weekAgo: '1 week geleden',
    weeksAgo: '{{count}} weken geleden',
    monthAgo: '1 maand geleden',
    monthsAgo: '{{count}} maanden geleden',
    yearAgo: '1 jaar geleden',
    yearsAgo: '{{count}} jaar geleden'
  },

  // Restaurant History
  restaurantHistory: {
    passedInspection: 'Inspectie geslaagd',
    receivedWarning: 'Waarschuwing ontvangen',
    inspectionTooOld: 'Inspectie is te oud',
    awaitingInspection: 'Wacht op nieuwe inspectie',
    receivedFine: 'Boete ontvangen',
    receivedPV: 'PV ontvangen'
  },

  // Recent Reports
  recentReports: {
    title: 'Recente Meldingen',
    ariaLabel: 'Recente Meldingen'
  },

  // Sidebar
  sidebar: {
    recentReports: 'Recente Meldingen',
    trends: 'Trending'
  },

  // Trends
  trends: {
    title: 'Trending Restaurants',
    loading: 'Trends laden...',
    error: 'Kon trends niet laden',
    noTrends: 'Geen trendgegevens beschikbaar',
    noTrendsSubtext: 'Trendgegevens verschijnen hier wanneer beschikbaar',
    cityNoTrends: 'Geen recente scorewijzigingen in {{city}}',
    cityNoTrendsSubtext: 'Inspecties hier behielden recent dezelfde score',
    showNationalTrends: 'Toon trends voor heel België',
    noUpwardTrends: 'Geen stijgende trends beschikbaar',
    noDownwardTrends: 'Geen dalende trends beschikbaar',
    restaurants: 'restaurants',
    summary: 'Trend Samenvatting',
    improving: 'Verbeterend',
    declining: 'Verslechterend',
    popular: 'Populair',
    new: 'Nieuw',
    reports: 'meldingen',
    points: 'punten',
    lastUpdated: 'Laatst bijgewerkt',
    cta: 'Klik op een restaurant om details en inspectiegeschiedenis te bekijken.',
    significantImprovements: '{{count}} significante verbeteringen',
    significantDeclines: '{{count}} significante verslechteringen',
    avgPoints: 'Gem: {{value}} punten',
    noResultsFiltered: 'Geen resultaten',
    minChange: 'Min verandering:',
    all: 'Alle',
    sortByChange: 'Verandering',
    sortByName: 'Naam',
    sortByDate: 'Datum',
    significantChanges: 'Grote veranderingen',
    recentInspections: 'Laatste 30 dagen',
    bigChanges: 'Alleen grote veranderingen',
    mostRecent: 'Meest recent',
    daysAgo: 'dagen geleden'
  },

  // Comparison badges
  comparison: {
    whyThisScore: 'Waarom deze score?',
    aboveAverage: 'boven gemiddelde',
    belowAverage: 'onder gemiddelde',
    verdict: {
      topCategory: 'De best beoordeelde {{category}} in {{area}}.',
      topPostal: 'Het best beoordeelde restaurant in {{postalCode}}.',
      topCity: 'Het best beoordeelde restaurant in {{cityName}}.',
      topPercentile: 'Top {{percentile}}% in {{cityName}}.',
      ranked: 'Gerangschikt #{{rank}} van {{total}} in {{area}}, scoort {{diff}} punten {{aboveBelow}}.'
    },
    breakdown: {
      history: 'Geschiedenis',
      forks: 'Officiële Beoordeling',
      reports: 'Gebruikersmeldingen',
      officialRating: 'officiële beoordeling',
      basedOnReports: 'Gebaseerd op {{count}} gebruikersmeldingen',
      noHistory: 'Geen inspectiegeschiedenis beschikbaar',
      historyWarning: 'Heeft waarschuwingen of boetes in geschiedenis',
      historyStrong: 'Slaagt consequent voor inspecties',
      historyNeutral: 'Gemengde inspectiegeschiedenis'
    },
    labels: {
      city: 'Stad',
      area: 'Gebied',
      category: 'Categorie'
    },
    betterThan: 'Beter dan {{percent}}%',
    inWorst: 'Bij de slechtste {{percent}}%',
    inBest: 'Bij de beste {{percent}}%',
    quality: {
      excellent: 'Uitstekend',
      good: 'Goed',
      average: 'Gemiddeld',
      belowAvg: 'Onder gem.'
    },
    historyStatus: {
      noData: 'Geen data',
      hasIssues: 'Heeft problemen',
      clean: 'Schoon',
      mixed: 'Gemengd'
    }
  },

  // Badge embed
  badge: {
    triggerLink: 'Jouw zaak?',
    modalTitle: 'Toon Je Beoordeling',
    modalDescription: 'Trots op je hygiënescore? Toon deze op je website of social media om vertrouwen te winnen bij klanten.',
    embedLabel: 'Plaats op je website',
    imageUrlLabel: 'Of deel de afbeeldings-URL',
    preview: 'Badge Voorbeeld',
    tabs: {
      embed: 'Embed Code',
      showcase: 'QR Showcase'
    },
    showcase: {
      scanToVerify: 'Scan om te verifiëren',
      downloadPng: 'Download PNG',
      downloading: 'Genereren...',
      printTip: 'Geoptimaliseerd voor afdrukken op 300 DPI',
      forks: '{{count}} Vorken',
      ratingLabel: {
        '5': 'Uitstekend',
        '4': 'Zeer Goed',
        '3': 'Goed',
        '2': 'Slecht',
        '1': 'Kritiek'
      }
    }
  },

  // Subscription
  subscription: {
    notifyMe: 'Waarschuw me bij beoordelingswijzigingen',
    title: 'Blijf Op De Hoogte',
    description: 'Ontvang een melding wanneer de inspectiescore van {{restaurantName}} verandert',
    emailPlaceholder: 'Vul je e-mailadres in',
    subscribe: 'Abonneren',
    subscribing: 'Abonneren...',
    success: 'Succesvol geabonneerd!',
    privacy: 'We gebruiken je e-mail alleen om je updates te sturen over de beoordeling van dit restaurant.',
    invalidEmail: 'Vul een geldig e-mailadres in',
    alreadySubscribed: 'Je bent al geabonneerd op updates voor dit restaurant',
    error: 'Abonneren mislukt. Probeer het later opnieuw.',
    close: 'Sluiten',
    onePersonWatching: '1 persoon volgt',
    peopleWatching: '{{count}} personen volgen'
  },

  score: {
    excellent: 'Uitstekend',
    good: 'Goed',
    poor: 'Slecht',
    bad: 'Zeer Slecht',
    unknown: 'Onbekend'
  },

  city: {
    subtitle: 'Restaurant hygiëne overzicht',
    noData: 'Geen gegevens beschikbaar voor {{city}}',
    noDataHint: 'Probeer restaurants in dit gebied te zoeken op de kaart',
    avgExplain: 'gemiddelde hygiënescore van {{count}} restaurants',
    alertTitle: 'Ontvang meldingen voor {{city}}',
    alertDescription: 'Wees de eerste die het weet wanneer voedselveiligheidsproblemen opduiken in {{city}}',
    alertSuccess: 'Je bent geabonneerd!',
    alertPlaceholder: 'jouw@email.com',
    alertButton: 'Waarschuw mij',
    alertError: 'Al geabonneerd of probeer het later opnieuw',
    avoid: 'Te Vermijden',
    safe: 'Veilige Keuzes',
    prose: {
      overview: '{{city}} heeft {{count}} geïnspecteerde restaurants met een gemiddelde hygiënescore van {{avg}}/5.',
      reports: '{{count}} voedselveiligheidsrapporten zijn ingediend door bezoekers in {{city}}.',
      topPick: 'Best beoordeeld: {{name}}.',
      warning: '{{count}} restaurants gemarkeerd voor slechte hygiëne.'
    }
  },

  province: {
    prose: {
      overview: '{{province}} heeft {{count}} geïnspecteerde restaurants met een gemiddelde hygiënescore van {{avg}}/5.',
      reports: '{{count}} voedselveiligheidsrapporten zijn ingediend in {{province}}.',
      topPick: 'Best beoordeeld: {{name}}.'
    }
  },

  chain: {
    sectionTitle: 'Onderdeel van een keten?',
    sectionBody: 'Er zijn {{count}} vestigingen met deze naam in onze database.',
    sectionAvg: 'Gemiddelde FAVV-score van alle vestigingen: {{avg}}/5',
    sectionLink: 'Bekijk alle vestigingen',
    pageSubtitle: 'Vestigingen met deze naam in België',
    avgExplain: 'gemiddelde FAVV-score over {{count}} geïnspecteerde vestigingen',
    scoredPct: '{{pct}}% van de vestigingen heeft een recente inspectiescore',
    locations: 'Vestigingen ({{count}})',
    sortCity: 'Per gemeente',
    sortScoreAsc: 'Score: laag → hoog',
    sortScoreDesc: 'Score: hoog → laag',
    distribution: 'Scoreverdeling',
    unscored: '{{count}} vestigingen zonder recente score',
    share: 'Delen',
    shareText: '{{name}}: gemiddelde FAVV-score {{avg}}/5 over {{count}} vestigingen',
    methodology: 'Gemiddelden op basis van officiële FAVV-inspectieresultaten per vestiging. Vestigingen zijn gegroepeerd op naam en kunnen tot verschillende uitbaters behoren.',
    noData: 'Geen gegevens gevonden voor deze keten',
    prose: {
      overview: '{{name}} telt {{count}} vestigingen in onze database, waarvan {{scored}} met een recente FAVV-inspectiescore. De gemiddelde score is {{avg}} op 5.'
    },
    rankings: {
      title: 'Ketens vergeleken',
      subtitle: 'Gemiddelde FAVV-inspectiescores per keten',
      intro: 'Vergelijk supermarkten, fastfood- en winkelketens op basis van de gemiddelde officiële FAVV-inspectiescore van hun vestigingen.',
      sortBySize: 'Aantal vestigingen',
      sortByScoreDesc: 'Score: hoog → laag',
      sortByScoreAsc: 'Score: laag → hoog',
      minSize: 'Min. vestigingen',
      locationCount: '{{count}} vestigingen',
      noData: 'Nog geen ketengegevens beschikbaar'
    }
  },

  backlog: {
    title: 'Inspectie-achterstand',
    subtitle: 'Actieve zaken waarvan de laatste FAVV-inspectie ongunstig was en minstens 2 jaar geleden is',
    statExplain: 'zaken met een ongunstige score en geen inspectieresultaat in 2+ jaar',
    oldest: 'Oudste ongunstige resultaat: {{date}}',
    allProvinces: 'Alle',
    lastInspection: 'Laatste inspectie {{date}} · {{years}} jaar geleden',
    loadMore: 'Toon meer ({{shown}}/{{total}})',
    noData: 'Geen gegevens beschikbaar',
    methodology: 'Gebaseerd op openbare FAVV-inspectieresultaten. Een oude score zegt niets over de huidige toestand; er is enkel geen recenter resultaat beschikbaar in de openbare data.'
  }
};

export default translations;
